import $ from "jquery";

$(function () {
  let loader_html = (
    '<div id="loader" class="d-flex justify-content-center" style="min-height: 600px;">' +
    '  <div class="spinner-border" role="status">' +
    '    <span class="visually-hidden">Loading...</span>' +
    '  </div>' +
    '</div>'
  )

  let results = $('div#results')
  let paginate_by = results.data('paginateby')

  function load_elements(elem, action = null, search = "", paginate_by = null, url=null) {
    let csrf = $('[name="csrfmiddlewaretoken"]').attr('value');
    if (url === null)
      url = elem.closest('div.object-api').data('api-url');
    results.html(loader_html)
    let data = {}
    if (action)
      data['action'] = action;
    if (search && !action)
      data['search'] = search;
    if (paginate_by)
      data['paginate_by'] = paginate_by;
    data['page'] = parseInt(results.data('page'))
    if (results.data('category'))
      data['category'] = results.data('category');
    if (results.data('concessionary'))
      data['concessionary'] = results.data('concessionary');
    if (results.data('subarea'))
      data['subarea'] = results.data('subarea');
    $.ajax({
      url: url,
      data: data,
      headers: {'X-CSRFToken': csrf},
      type: 'POST',
    }).done(function (data) {
      results.html(data);
      let new_page = $('div#new-page').html()
      results.data('page', new_page)
      let height = results.height();
      results.css('height', height)
    });

  }

  // load works API
  $(document).on('click', '.object-api button.nav-link', function () {
    let action = $(this).data('action');
    load_elements($(this), action, "", paginate_by);
  })

  $(document).on('submit', 'form#search-into-object', function (e) {
    e.preventDefault();
    let search = $('input[name="search"]').val()
    $('input[name=hidden-search]').val(search)
    load_elements($(this), "", search, paginate_by)
    return false;
  });

  $(document).on('click', 'ul#ajax-pagination span', function () {
    console.log("click ajax-pagination")
    let url = $(this).attr('href')
    if (!url)
      return;
    let action = $(this).data('action-pagination');
    let search = $('input[name="hidden-search"]').val()
    load_elements(results, action, search, paginate_by, url)
  });
});
